import { Education } from '../types';

export const education: Education[] = [
  {
    id: "1",
    degree: "Bachelor of Science, Electrical Engineering and Computer Science",
    institution: "University of California, Berkeley",
    startDate: "2009-09",
    endDate: "2013-05",
    location: "Berkeley, CA",
    description: "Combined EE and CS program, with a focus on CS. Authored a research paper on the security implications of brain-computer interfaces.",
    relevantCoursework: [
      "Electrical Engineering",
      "Computer Science",
      "Brain-Computer Interfaces",
      "Security Research",
      "Software Engineering"
    ]
  },
  {
    id: "2",
    degree: "Google Project Management Certificate",
    institution: "Coursera",
    startDate: "2023-01",
    endDate: "2023-01",
    location: "Online",
    description: "Comprehensive project management certification covering modern project management methodologies and tools.",
    relevantCoursework: [
      "Project Management Fundamentals",
      "Agile Methodologies",
      "Risk Management",
      "Stakeholder Communication",
      "Project Planning & Execution"
    ]
  },
  {
    id: "3",
    degree: "Project Management Fundamentals",
    institution: "Professional Development",
    startDate: "2022-01",
    endDate: "2022-01",
    location: "Professional Training",
    description: "Core project management principles and best practices for technical project leadership.",
    relevantCoursework: [
      "Project Planning",
      "Team Leadership",
      "Resource Management",
      "Quality Assurance",
      "Project Delivery"
    ]
  }
]; 